// Property type factories used to build appearance editors
import { StrokeType, FillType, FontType } from "../PropertyTypes";

// Gann category - includes Gann-based drawing tools
const gannRegistry = {
  displayName: "Gann",
  interactives: {
    gannFan: {
      displayName: "Gann Fan",
      key: "gannFan",
      icon: "Gann_Fan",
      propName: "fans",
      component: "GannFan",
      defaultOptionsForAppearance: [
        StrokeType({
          name: "stroke",
          displayName: "Cor da Linha",
          defaultValue: {
            color: "#888888",
            dash: "Solid",
            width: 1,
            opacity: 0.1,
          },
        }),
        FillType({
          name: "fill",
          displayName: "Preenchimento (primeira cor)",
          defaultValue: { color: "#888888", opacity: 0.15 },
        }),
        FontType({
          name: "font",
          displayName: "Fonte",
          defaultValue: {
            fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
            color: "#888888",
            fontSize: 12,
          },
        }),
      ],
    },
  },
};

export default gannRegistry;
